import {EntrySingletonPageShared} from './../../EntrySingletonPageShared'
import '../../css/style.scss'
import {UIWStoreController} from './UIWStoreController'
import {Sound} from '../../../shared/scripts/Sound'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {UISingletonScrollController} from '../../../shared/scripts/ui_scroll_controller/UISingletonScrollController'
import {UIWNotificationController} from '../notifications/UIWNotificationController'

class EntryStore extends EntryShared {
    constructor() {
        super()
        void this.init()
    }

    async init() {
        Sound.loadSounds()

        await EntryShared.initializeEntry()
        this.initializeNotification(new UIWNotificationController())

        const headerController = new UIWHeaderController()
        new UISidebarController()

        new UIWStoreController()
        new UISingletonScrollController()

        EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    }
}

new EntryStore()
